import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DeviceWithoutLegacyPassword } from "../../../../generated/types";
import {
  LicenseModal,
  LicenseSection,
  useDeviceLicenses,
} from "../../device/LicenseModal";
import { EditButton } from "./DetailCard";

/** Licences d'un produit serenity sur la fiche élevage, modifiables avec la modale du PSC. */
export const DeviceLicenses = ({
  device,
  companyId,
}: {
  device: DeviceWithoutLegacyPassword;
  companyId: number;
}) => {
  const { t } = useTranslation();
  const { activeCodes, isLoading, reload } = useDeviceLicenses(device.uuid);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex items-center gap-2 pl-2">
      <span className="text-xs text-grey-medium shrink-0">
        {t("device-licenses")}
      </span>
      {isLoading ? (
        <span className="text-xs text-grey-readable">{t("loading")}</span>
      ) : (
        <LicenseSection activeCodes={activeCodes} />
      )}
      <span className="ml-auto shrink-0">
        <EditButton
          label={t("device-license")}
          onClick={() => setIsOpen(true)}
        />
      </span>
      <LicenseModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        device={device}
        companyId={companyId}
        activeCodes={activeCodes}
        onSaved={reload}
      />
    </div>
  );
};
